/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-return-assign */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useContext, useEffect, useState } from 'react';
import {
  Router, Route, Switch, Link, useLocation, useParams,
} from 'react-router-dom';
import history from '../../history';
import { store } from '../../store';
import { usePrevState } from '../../utils/hooks';
import {
  ErrorPageContainer,
} from '..';

import {
  LandingComponent,
  SubmissionComponent,
} from '../../components';

import './app-container.scss';

type AppContainerTypes = {} & typeof defaultProps;
const defaultProps = {};

const AppContainer = (props: AppContainerTypes) => {
  const globalStore: any = useContext(store);
  const { state: globalStoreState, dispatch: globalStoreDispatch }: any = globalStore;
  const { userSessionData } = globalStoreState;
  const prevSessionUserData: any = usePrevState(userSessionData);
  const [mobileNavOpen, isMobileNavOpen] = useState(false);

  const [showPolicy, setShowPolicy] = useState(true);

  const toggleMobileNavMenu = () => {
    isMobileNavOpen(!mobileNavOpen);
  };

  const updateStore = (name: string, data: any) => {
    globalStoreDispatch({ type: { name, data } });
  };

  useEffect(() => {
    if (!prevSessionUserData || !userSessionData) return;
    if (prevSessionUserData !== userSessionData) {
      console.log(userSessionData);
    }
  }, [prevSessionUserData, userSessionData]);

  const navClick = (path: string) => {
    if (!path) return;
    isMobileNavOpen(false);
    history.push(path);
    updateStore('UPDATE_CURRENT_PATH', path);
  };

  const onClickDiscord = () => {
    window.open('https://discord.gg/GuGJgpzGXV', '_blank');
  };

  const onClickTwitter = () => {
    window.open('https://twitter.com/AOmetaverse', '_blank');
  };

  useEffect(() => {
    const hasAgreed = localStorage.getItem('privacyPolicyAgree');
    if (hasAgreed) {
      setShowPolicy(false);
    } else {
      setShowPolicy(true);
    }
  }, []);

  const onClickContinue = () => {
    setShowPolicy(false);
    localStorage.setItem('privacyPolicyAgree', 'true');
  };

  return (
    <Router history={history}>

      {showPolicy ? (
        <div className="privacy-policy-popup">
          <div className="notice">
            This website uses cookies to enhance and personalise your experience.
            For more information about our collection and use of your information,
            including our use of cookies, please check out our
            {' '}
            <a href="https://www.tennis.com.au/privacy" target="_blank" rel="noopener noreferrer">
              privacy policy
            </a>
          </div>
          <div className="agree-button" onClick={() => onClickContinue()}>
            CONTINUE
          </div>
        </div>
      ) : <></>}

      <div className="app-container">
        <header className="page-header">
          <div className="page-header-content">
            <div className="project-logo" />
            <h1>17-30 JAN</h1>
            <div className="project-socials">
              <div className="social-button" onClick={() => onClickDiscord()}>
                <div className="social-logo discord" />
                <span>DISCORD</span>
              </div>
              <div className="social-button" onClick={() => onClickTwitter()}>
                <div className="social-logo twitter" />
                <span>TWITTER</span>
              </div>
            </div>
            {/* <div
              className="mobile-navigation-button"
              onClick={() => toggleMobileNavMenu()}
            /> */}
          </div>
        </header>

        <section className="page-content">
          <Switch>
            <Route exact path="/">
              <LandingComponent />
              <SubmissionComponent />
            </Route>
            <Route exact path="*">
              <ErrorPageContainer />
            </Route>
          </Switch>
        </section>
      </div>
    </Router>
  );
};

AppContainer.defaultProps = defaultProps;

export default AppContainer;
